import React, { useEffect, useState } from 'react';
import { useSessionSelector } from '../../redux/selectors';
import { getColorLightness } from '../../utils/colorHelpers';
import AccessibilityStatement from '../AccessibilityStatement';
import { StyledFooterBranding } from './FooterBranding.styled';
import { ReactComponent as LogoDark } from './powered-by-sb.svg';
import { ReactComponent as LogoLight } from './powered-by-sb_white.svg';

export default interface IFooterBranding {
  role?: React.AriaRole;
}

export const FooterBranding: React.FC<IFooterBranding> = (props) => {
  const style = useSessionSelector().style;
  const stageBackground = style.colors?.stageBackground;

  const [isStageLight, setIsStageLight] = useState<boolean>(false);

  useEffect(() => {
    setIsStageLight(getColorLightness(stageBackground) === 'light');
  }, [stageBackground]);

  const logoTitle = 'Powered By Solaris';

  return (
    <StyledFooterBranding {...props}>
      {isStageLight ? (
        <LogoDark title={logoTitle} />
      ) : (
        <LogoLight title={logoTitle} />
      )}
      <AccessibilityStatement />
    </StyledFooterBranding>
  );
};
